import {defineComponent, h, PropType} from "vue";

export default defineComponent({
    props: {
        left: {
            type: Number as PropType<number>,
            default: 0
        },
        nodeCount: {
            type: Number as PropType<number>,
            default: 0
        },
        size: {
            type: Number as PropType<number>,
            default: 10
        },
        bg: {
            type: String as PropType<string>,
            required: false,
            default: "gray"
        },
        textColor: {
            type: String as PropType<string>,
            required: false,
            default: "gray"
        },
        selectNode: {
            type: Number as PropType<number>,
            required: false,
            default: 0
        }
    },
    setup(props) {
        return () =>
            h(
                "div",
                {
                    style: {
                        left: (props.left - 0.8) + "%",
                        position: "absolute",
                        borderRadius: "150px",
                        backgroundColor: props.bg,
                        width: '8px',
                        height: '8px',
                        fontSize: "9px",
                        top: (props.size + 1) + 'px',
                        zIndex: 0
                    }
                },
            );
    }
});
